import {
	Button,
	ButtonGroup,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
} from "@material-ui/core";
import ThumbDownAltIcon from "@material-ui/icons/ThumbDownAlt";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { get } from "lodash";
import React, { useState } from "react";
import { useMutation, useNotify, useRefresh, useTranslate } from "react-admin";

const SetStatusButton = ({
	record,
	status,
	Icon,
	showDialog = false,
	...props
}) => {
	const canShowDialog = status === "rejected" && showDialog;
	const translate = useTranslate();
	const refresh = useRefresh();
	const notify = useNotify();
	const [isOpen, setIsOpen] = useState(false);
	const [supervisorNotes, setSupervisorNotes] = useState(
		get(record, "supervisor_notes", "")
	);
	const [handleApprove, { loading }] = useMutation(
		{
			type: "update",
			resource: "bookmaker-approvals",
			payload: {
				id: record.id,
				data: {
					user_id: record.user_id,
					bookmaker_id: record.bookmaker_id,
					notes: record.notes,
					supervisor_notes: supervisorNotes,
					status,
				},
			},
		},
		{
			onSuccess: ({ data }) => {
				notify(translate(`resources.bookmaker-approvals.messages.${status}`));
				refresh();
			},
			onError: () =>
				notify(translate("resources.bookmaker-approvals.messages.error")),
		}
	);
	const handleClose = () => setIsOpen(false);
	const handleClick = () => {
		if (canShowDialog) {
			setIsOpen(true);
		} else {
			handleApprove();
		}
	};
	if (get(record, "status") === status) {
		return null;
	}
	return (
		<>
			{canShowDialog && (
				<Dialog open={isOpen} onClose={handleClose}>
					<DialogTitle>
						{translate("resources.bookmaker-approvals.actions.reject.title")}
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{translate(
								"resources.bookmaker-approvals.actions.reject.content"
							)}
						</DialogContentText>
						<TextField
							defaultValue={supervisorNotes}
							onChange={(e) => setSupervisorNotes(e.target.value)}
							autoFocus
							margin="dense"
							id="supervisor_notes"
							label={translate(
								"resources.bookmaker-approvals.fields.supervisor_notes"
							)}
							multiline
							rows={5}
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleApprove} disabled={loading}>
							{translate(
								"resources.bookmaker-approvals.actions.reject.confirm"
							)}
						</Button>
						<Button onClick={handleClose} disabled={loading}>
							{translate("ra.action.cancel")}
						</Button>
					</DialogActions>
				</Dialog>
			)}
			<Button {...props} onClick={handleClick} disabled={loading}>
				<Icon />
			</Button>
		</>
	);
};

const SettingsField = ({ record, onViewDetailsClick }) => {
	const handleClick = () => onViewDetailsClick(record);
	return (
		<ButtonGroup disableElevation color="primary" variant="text" size="small">
			<SetStatusButton
				record={record}
				status="approved"
				Icon={ThumbUpAltIcon}
			/>
			<Button onClick={handleClick}>
				<VisibilityIcon />
			</Button>
			<SetStatusButton
				record={record}
				status="rejected"
				showDialog={true}
				Icon={ThumbDownAltIcon}
			/>
		</ButtonGroup>
	);
};

export default SettingsField;
